import { IconButton } from "@mui/material";
import { useSelector } from "react-redux";
import OpenInNewRoundedIcon from '@mui/icons-material/OpenInNewRounded';
import { useNavigate } from "react-router-dom";
import WeatherDailyTable from "./WeatherDailyTable";
import WeatherDailyGraph from './WeatherDayGraph';
import { Skeleton } from "@mui/material"
import SimpleWhiteBox from "./SimpleWhiteBox";

export default function HomeDailyRecup(props) {
  const favuriteCity = useSelector(state => state.city.city)
  const navigate = useNavigate()
  const weather = useSelector(state => state.weather.weather)

  const id = favuriteCity ? favuriteCity.id : undefined

  const handleOpenLink = () => {
    navigate('/city/'+id)
  }

  return (
    <div>
      {
        favuriteCity ? 
          
            
            <SimpleWhiteBox content={
              <>
                {
                  weather[id] ? 
                    <>
                      <div className="row">
                        <div className="col-10">
                          <h2>{favuriteCity.name}</h2>
                        </div>
                        <div className="col-2">
                          <IconButton onClick={handleOpenLink} style={{float:'right'}}>
                            <OpenInNewRoundedIcon />
                          </IconButton>
                        </div>
                      </div>
                      <hr />
                      <WeatherDailyGraph weather={filterDayInDate(new Date(), weather[id].weather.hourly)} />
                      <hr />
                      <WeatherDailyTable weather={weather[id].weather.daily[0]} min={false} />
                    </>
                    :
                    <>
                      <div>
                        <br />
                        <Skeleton variant="rectangular" width="90%" height={118} style={centerStyle} />
                        <br />
                        <Skeleton variant="rectangular" width="90%" height={118} style={centerStyle} />
                        <br />
                        <Skeleton variant="rectangular" width="90%" height={118} style={centerStyle} />
                        <br/> 
                      </div>
                      
                    </>
                }
              </>
            }
            />

          :
          <></>
      }
    </div>
  )
}

function filterDayInDate(dateForFilter, list) {
  return list.filter(el => {
    let d = new Date(el.dt * 1000)
    return dateForFilter.getDate() == d.getDate() && dateForFilter.getMonth() == d.getMonth() && dateForFilter.getFullYear() == d.getFullYear()
  })
}

const centerStyle = {marginLeft:'auto', marginRight:'auto'}